import type { Locale } from '@susu/headless-commerce/config/locale'
import { NavBack } from '@susu/headless-commerce/features/navigation/components/NavBack'
import { NavCards } from '@susu/headless-commerce/features/navigation/components/NavCards/NavCards'
import { NavCloseButton } from '@susu/headless-commerce/features/navigation/components/NavCloseButton'
import { NavLinks } from '@susu/headless-commerce/features/navigation/components/NavLinks'
import type { Navigation } from '@susu/headless-commerce/features/navigation/domain'
import { isNotUndefined } from '@susu/undefined'
import classNames from 'classnames'
import styles from './NavSubmenu.module.scss'

export type NavSubmenuProps = {
  className?: string
  isCards?: boolean
  locale: Locale
  navigation: Navigation
  open?: boolean
}

export const NavSubmenu = ({
  className,
  isCards = false,
  locale,
  navigation,
  open = false,
}: NavSubmenuProps) => {
  const finalClassName = classNames(
    styles['nav__submenu'],
    'nav__submenu',
    {
      [`${styles['nav__submenu--opened']} nav__submenu--opened`]: open,
    },
    className,
  )

  return (
    <div className={finalClassName} data-testid="nav-submenu">
      <NavBack />
      <NavCloseButton className={'nav__submenu-close-btn'} />
      {isNotUndefined(navigation.title) && (
        <span className={'nav__submenu-title'}>{navigation.title}</span>
      )}
      {isNotUndefined(navigation.groups) && isCards === true ? (
        <NavCards navigation={navigation} locale={locale} />
      ) : (
        <NavLinks navigation={navigation} isSubMenu={true} />
      )}
    </div>
  )
}
